'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var NewCalibrationAnalysisController = function NewCalibrationAnalysisController($scope, $log, retrieverConstants, dataRetrieverService, newCalibrationAnalysisService, calibrationAnalysisConstants) {
  $scope.isDuplicateCalibrationAnalysis = false;
  $scope.metricList = [calibrationAnalysisConstants.UNTRUNCATED_DEMAND_METRIC, calibrationAnalysisConstants.IDV_BOOKINGS_METRIC];
  $scope.calibrationNameRegex = /^[A-Za-z0-9 -]{6,50}$/;
  $scope.isCalibrationValid = true;
  $scope.initUiDates = function () {
    $scope.maxDateTo = $scope.newCalibrationAnalysis.dateRangeTo;
    $scope.maxDateFrom = $scope.newCalibrationAnalysis.dateRangeFrom;
    $scope.uiDateRangeTo = $scope.newCalibrationAnalysis.dateRangeTo;
    $scope.uiDateRangeFrom = $scope.newCalibrationAnalysis.dateRangeFrom;
    $scope.maxShareReviewDateFrom = $scope.newCalibrationAnalysis.dateRangeTo.subtract(6, 'days');
    $scope.maxShareReviewDateTo = $scope.newCalibrationAnalysis.dateRangeTo;
    $scope.uiShareDateRangeTo = $scope.newCalibrationAnalysis.shareReviewDateRangeTo;
    $scope.uiShareDateRangeFrom = $scope.newCalibrationAnalysis.shareReviewDateRangeFrom;
  };
  $scope.initNewCalibrationAnalysisModel = function () {
    $scope.newCalibrationAnalysis.markets = _.map($scope.marketList, 'value');
    $scope.newCalibrationAnalysis.travelTimeBucketWidth = 60;
    $scope.newCalibrationAnalysis.fareBucket = 10;
  };
  $scope.initSelectedMarkets = function () {
    $scope.newCalibrationAnalysis.selectedMarkets = _.map($scope.newCalibrationAnalysis.markets, function (market) {
      return {
        market: market,
        selected: true
      };
    });
  };
  $scope.initModel = function () {
    $scope.initUiDates();
    $scope.initNewCalibrationAnalysisModel();
    $scope.initSelectedMarkets();
  };
  $scope.initModel();
  $scope.showSubmitCalibrationAnalysisModal = function () {
    $scope.openSubmitModal();
  };
  $scope.validateUniqNameAndSubmit = function () {
    $scope.isDuplicateCalibrationAnalysis = false;
    dataRetrieverService.getDataRetriever(retrieverConstants.CALIBRATION_ANALYSIS_SCREEN, retrieverConstants.DEMAND_SHARES_MODE).retrieveComponentData('demand-shares').then(function (data) {
      var selectedMarkets = _.chain($scope.newCalibrationAnalysis.selectedMarkets).filter('selected').map('market').value();
      data = _.filter(data, function (it) {
        return _.includes(selectedMarkets, it.market);
      });
      var filteredExistingCalibrationAnalyzes = _.filter(data, function (analysis) {
        return analysis.calibrationName === $scope.newCalibrationAnalysis.calibrationName;
      });
      if (filteredExistingCalibrationAnalyzes.length > 0) {
        $scope.isDuplicateCalibrationAnalysis = true;
      } else {
        $scope.sendNewCalibrationAnalysisRequest();
      }
    });
  };
  $scope.isSelectedMarketsEmpty = function () {
    return !_.chain($scope.newCalibrationAnalysis.selectedMarkets).filter('selected').size().value();
  };
  function onRequestSuccess() {
    $scope.submitted = true;
    toastr.success('Your calibration analysis has been successfully submitted.');
  }
  function onRequestFail() {
    $scope.submitted = true;
    $log.error('NewCalibrationAnalysisController: onRequestFail - An error has occurred. Please try again');
    toastr.error('An error has occurred. Please try again.');
  }
  $scope.sendNewCalibrationAnalysisRequest = function () {
    newCalibrationAnalysisService.sendNewCalibrationAnalysisRequest($scope.newCalibrationAnalysis).then(onRequestSuccess, onRequestFail)["finally"](function () {
      $scope.closeSubmitModal();
      $scope.$emit('online-logit-calibration:back-to-calibration-screen');
    });
  };
  $scope.$watch('newCalibrationAnalysis.markets', function (newValue, oldValue) {
    if (!newValue) {
      return;
    }
    if (newValue !== oldValue) {
      $scope.initSelectedMarkets();
    }
  });
  $scope.$watch('uiDateRangeTo', function (newValue, oldValue) {
    if (!newValue) {
      return;
    }
    if (!newValue.isSame(oldValue)) {
      $scope.newCalibrationAnalysis.dateRangeTo = newValue;
    }
    $scope.maxDateFrom = $scope.newCalibrationAnalysis.dateRangeTo.subtract(90, 'days');
    $scope.isValidationFailed = function (validationName) {
      return $scope.reviewParams.travelTimeBucketWidth.$dirty && $scope.reviewParams.travelTimeBucketWidth.$error[validationName];
    };
    if ($scope.newCalibrationAnalysis.dateRangeFrom.isAfter($scope.maxDateFrom)) {
      $scope.uiDateRangeFrom = $scope.maxDateFrom;
    }
  });
  $scope.$watch('uiDateRangeFrom', function (newValue, oldValue) {
    if (!newValue) {
      return;
    }
    if (!newValue.isSame(oldValue)) {
      $scope.newCalibrationAnalysis.dateRangeFrom = newValue;
    }
  });
  $scope.$watch('uiShareDateRangeTo', function (newValue, oldValue) {
    if (!newValue) {
      $scope.isCalibrationValid = false;
      return;
    }
    if (!newValue.isSame(oldValue)) {
      $scope.newCalibrationAnalysis.shareReviewDateRangeTo = newValue;
      $scope.isCalibrationValid = true;
    }
    $scope.newCalibrationAnalysis.shareReviewDateRangeFrom = newValue.subtract(6, 'days');
    if (!$scope.uiShareDateRangeFrom || !$scope.uiShareDateRangeFrom.isSame($scope.newCalibrationAnalysis.shareReviewDateRangeFrom)) {
      $scope.uiShareDateRangeFrom = $scope.newCalibrationAnalysis.shareReviewDateRangeFrom;
    }
  });
  $scope.$watch('uiShareDateRangeFrom', function (newValue, oldValue) {
    if (!newValue) {
      $scope.isCalibrationValid = false;
      return;
    }
    if (!newValue.isSame(oldValue)) {
      $scope.isCalibrationValid = true;
      $scope.newCalibrationAnalysis.shareReviewDateRangeFrom = newValue;
    }
    $scope.newCalibrationAnalysis.shareReviewDateRangeTo = newValue.add(6, 'days');
    if (!$scope.uiShareDateRangeTo || !$scope.uiShareDateRangeTo.isSame($scope.newCalibrationAnalysis.shareReviewDateRangeTo)) {
      $scope.uiShareDateRangeTo = $scope.newCalibrationAnalysis.shareReviewDateRangeTo;
    }
  });
  $scope.setValidationFlag = function () {
    if (_.isEmpty($scope.newCalibrationAnalysis) || _.isNil($scope.newCalibrationAnalysis.markets)) {
      return;
    }
    $scope.isCalibrationValid = validateReviewParams($scope.newCalibrationAnalysis);
  };
  function validateReviewParams(calibration) {
    return validateTravelTimeBucketWidth(calibration) && validateFareBucket(calibration) && validateShareDateRange(calibration);
  }
  function validateTravelTimeBucketWidth(calibration) {
    return calibration.travelTimeBucketWidth && calibration.travelTimeBucketWidth >= 0 && calibration.travelTimeBucketWidth % 60 === 0;
  }
  function validateShareDateRange(calibration) {
    return !_.isNil(calibration.shareReviewDateRangeFrom) || !_.isNil(calibration.shareReviewDateRangeTo);
  }
  function validateFareBucket(calibration) {
    return calibration.fareBucket && calibration.fareBucket >= 0;
  }
  $scope.$watchGroup(['newCalibrationAnalysis.travelTimeBucketWidth', 'newCalibrationAnalysis.fareBucket'], function (newValues, oldValues) {
    if (!_.isEqual(newValues, oldValues)) {
      $scope.setValidationFlag();
    }
  });
};
NewCalibrationAnalysisController.$inject = ['$scope', '$log', 'DataRetrieverConstantsService', 'DataRetrieverService', 'NewCalibrationAnalysisService', 'CalibrationAnalysisConstants'];
module.exports = NewCalibrationAnalysisController;